var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('svg', { class: _vm.svgClass, style: _vm.innerStyle, attrs: { "aria-hidden": "true" }, on: { "click": function click($event) {
        return _vm.$emit('click', $event);
      } } }, [_c('use', { attrs: { "xlink:href": _vm.iconName } })]);
};
var staticRenderFns = [];

export { render, staticRenderFns };